<!-- Clicking on the version will trigger forceReload -->
<div *ngIf="authEnabled; else alternative">
  Version<b> {{ version }}</b>
</div>
<ng-template #alternative>
  Version
  <button kendoButton (click)="forceReload()"> {{ version }}</button>
</ng-template>


